/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Link } from "react-router-dom";
import styled from "styled-components";
import { Box, FlexContainer, theme } from "@nordcloud/gnui";
import { HeaderWrapper } from "~/layout/styles";
import { User } from "./components";
import { IbmWrapper, McaWrapper } from "./styles";

export function Header() {
  return (
    <HeaderWrapper>
      <Box spacing="spacing04" padding={theme.spacing.spacing04} mb={0} css={{ borderRadius: 0 }}>
        <FlexContainer justifyContent="space-between" css={{ height: "2.5rem", width: "100%" }}>
          <StyledLink to="/">
            <IbmWrapper>IBM </IbmWrapper>
            <McaWrapper>
              <span className="full-name">Multicloud Panel</span>
              <span className="abbreviated-name">MCP</span>
            </McaWrapper>
          </StyledLink>
          <User />
        </FlexContainer>
      </Box>
    </HeaderWrapper>
  );
}

const StyledLink = styled(Link)`
  color: inherit;
  white-space: nowrap;
  font-size: 2rem;
  &:hover {
    text-decoration: none;
    color: inherit;
  }
`;
